/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useTheme } from '@mui/material/styles'

export type ColorWithAccent = [string, string]

const useContentfulColors = () => {
  const { palette } = useTheme()

  const sectionColorMap = new Map<string, ColorWithAccent>([
    ['white', [palette.common.white, palette.common.black]],
    ['black', [palette.common.black, palette.common.white]],
    ['grey', [palette.grey[100], palette.common.black]],
    ['grey-lightest', [palette.grey[100], palette.common.black]],
    ['grey-light', [palette.grey[200], palette.common.black]],
    ['grey-medium-light', [palette.grey[300], palette.common.black]],
    ['grey-medium', [palette.grey[400], palette.common.white]],
    ['grey-medium-dark', [palette.grey[500], palette.common.white]],
    ['grey-dark', [palette.grey[600], palette.common.white]],
    ['grey-darkest', [palette.grey[800], palette.common.white]],
    ['blue', [palette.primary.main, palette.common.white]],
    ['primary-light', [palette.primary.light, palette.common.white]],
    ['primary', [palette.primary.main, palette.common.white]],
    ['primary-dark', [palette.primary.dark, palette.common.white]],
    ['secondary-light', [palette.secondary.light, palette.common.white]],
    ['secondary', [palette.secondary.main, palette.common.white]],
    ['secondary-dark', [palette.secondary.dark, palette.common.white]],
    ['success-light', [palette.success.contrastText, palette.common.black]],
    ['success-medium-light', [palette.success.light, palette.common.white]],
    ['success', [palette.success.main, palette.common.white]],
    ['success-dark', [palette.success.dark, palette.common.white]],
    ['info-light', [palette.info.contrastText, palette.common.black]],
    ['info-medium-light', [palette.info.light, palette.common.white]],
    ['info', [palette.info.main, palette.common.white]],
    ['info-dark', [palette.info.dark, palette.common.white]],
    ['warning-light', [palette.warning.contrastText, palette.common.black]],
    ['warning-medium-light', [palette.warning.light, palette.common.white]],
    ['warning', [palette.warning.main, palette.common.white]],
    ['warning-dark', [palette.warning.dark, palette.common.white]],
    ['error-light', [palette.error.contrastText, palette.common.black]],
    ['error-medium-light', [palette.error.light, palette.common.white]],
    ['error', [palette.error.main, palette.common.white]],
    ['error-dark', [palette.error.dark, palette.common.white]],
    ['accent', [palette.accent as unknown as string, palette.common.white]],
    [
      'accent-dark',
      [palette.accentDark as unknown as string, palette.common.white],
    ],
    ['orange', [palette.orange.main, palette.common.white]],
  ])

  return sectionColorMap
}

export default useContentfulColors
